import React from 'react'
import { PrimaryText } from '../../../styles/global'

const TabList = [
  {
    id: 1,
    name: "All",
  },{
    id: 2,
    name: "Web And Mobile",
  },{
    id: 3,
    name: "AI And ML",
  }
  
]

const Tabs = ({CurrentCategory,setCurrentCategory}) => {
  return (
    <div className='flex justify-center items-center w-full '>

      <div className='flex justify-center items-center w-full '>

        {TabList.map((tab) => {
          return (
            <div onClick={()=>setCurrentCategory(tab.name)} key={tab.id} className={`cursor-pointer  flex justify-center items-center md:w-1/5 m-6 md:m-10 mt-0 h-10  ${ CurrentCategory===tab.name&& "border-b-2 border-[#ff5757]"}`}>
              <PrimaryText className=' text-gray-400  text-xs md:text-sm'>{tab.name}</PrimaryText>
            </div>
          )
        })}

      </div>

    </div>
  )
}

export default Tabs